export const DashboardActionTypes = {
    DASHBOARD_DATA_FIRST: '@@auth/DASHBOARD_DATA_FIRST',
    DASHBOARD_DATA_LOADING: '@@auth/DASHBOARD_DATA_LOADING',
    DASHBOARD_DATA_SUCCESS: '@@auth/DASHBOARD_DATA_SUCCESS',
    DASHBOARD_DATA_ERROR: '@@auth/DASHBOARD_DATA_ERROR',
    
    
    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST',
    STATE_EMPTY_SUCCESS: '@@auth/STATE_EMPTY_SUCCESS',

};
